import React from 'react';
import styles from './Modal.module.scss';
import { Button, Icon } from 'components/ui';
import ReactModal from 'react-modal';
import clsx from 'clsx';
import SmallPreLoader from 'components/ui/SmallPreLoader/SmallPreLoader';

type ModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleOk?: () => void;
  name?: string;
  title: any;
  okBtnName?: string;
  cancelBtnName?: string;
  isLoading?: boolean;
};
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement('#modal');

const Modal: React.FC<ModalProps> = ({
  isOpen,
  handleClose,
  handleOk,
  title,
  okBtnName = 'OK',
  cancelBtnName = 'Cancel',
  isLoading = false,
}) => (
  <ReactModal isOpen={isOpen} style={customStyles}>
    {!isLoading ? (
      <div className={styles['root']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['buttons']}>
          <Button id="delete" className={styles['button']} onClick={handleOk}>
            {okBtnName}
          </Button>
          <Button className={clsx(styles['button'], 'ml-3')} onClick={handleClose}>
            {cancelBtnName}
          </Button>
        </div>
        <Icon className={styles['icon']} name="close" onClick={handleClose} />
      </div>
    ) : (
      <SmallPreLoader isDisabled={true} />
    )}
  </ReactModal>
);

export default Modal;
